import { useEffect, useState } from "react";
import Nav from "@/components/Header/Nav/Nav.tsx";
import Header from "@/components/Header/Header.tsx";
import Footer from "@/components/Footer/Footer.tsx";
import ScrollingText from "@/components/ScrollingText";
import GridComponent from "@/components/GridComponent/GridComponent";
import OpenMenuBlock from "@/components/OpenMenuBlock/OpenMenuBlock";
import ServiceBlockBerlin from "@/components/ServiceBlockBerlin/ServiceBlockBerlin";
import { useTranslation } from "react-i18next";
import FaqBlock from "@/components/FAQ/FAQBlock";
import RepairServiceBig from "@/components/RepairService/RepairServiceBig";
import CookiePopupButton from "../components/CookieBanner/CookiePopupButton";
import { getFaqDataEU } from "@/data/faq/data-faq-index"; // Імпорт функції для отримання FAQ
import { Helmet } from "react-helmet";

interface SliderImage {
  src1920: string;
  src1440: string;
  src768: string;
  src320: string;
  alt: string;
  imageType: "full" | "partial";
  className?: string;
}

const headerSlider: SliderImage[] = [
  {
    src1920: "/images/EU/slide1_1920.png",
    src1440: "/images/EU/slide1_1440.png",
    src768: "/images/EU/slide1_768.png",
    src320: "/images/EU/slide1_320.png",
    alt: "Slide 3",
    imageType: "partial",
  },
  {
    src1920: "/images/EU/slide2_1920.png",
    src1440: "/images/EU/slide2_1440.png",
    src768: "/images/EU/slide2_768.png",
    src320: "/images/EU/slide2_320.png",
    alt: "Slide 2",
    imageType: "partial",
    className: "slide2-eu",
  },
  {
    src1920: "/images/EU/slide3_1920.png",
    src1440: "/images/EU/slide3_1440.png",
    src768: "/images/EU/slide3_768.png",
    src320: "/images/EU/slide3_320.png",
    alt: "Slide 1",
    imageType: "partial",
    className: "slide3-eu",
  },
];

const ServiceEU = () => {
  const { t } = useTranslation("pages");

  // Створюємо стан для faqData
  const [faqData, setFaqData] = useState<
    { question: string; answer: string }[] | null
  >(null);

  useEffect(() => {
    // Завантажуємо faqData при монтуванні компонента
    const fetchFaqData = async () => {
      const data = await getFaqDataEU(); // Отримуємо дані через асинхронну функцію
      setFaqData(data); // Зберігаємо їх у стан
    };
    fetchFaqData(); // Викликаємо функцію для завантаження
  }, []); // Порожній масив залежностей означає, що ефект виконується лише один раз при монтуванні компонента

  useEffect(() => {
    window.scrollTo(0, 0); // Прокручування сторінки на верх при монтуванні
  }, []);

  const gridItems = t("serviceEU.grid.items", {
    returnObjects: true,
  }) as Array<{
    title: string;
    description: string;
  }>;

  const gridData = [
    {
      icon: "/images/Grid/superman-ico.svg",
      title: gridItems[0].title,
      description: gridItems[0].description,
    },
    {
      icon: "/images/Grid/graph-ico.svg",
      title: gridItems[1].title,
      description: gridItems[1].description,
    },
    {
      icon: "/images/Grid/chckcar-ico.svg",
      title: gridItems[2].title,
      description: gridItems[2].description,
    },
    {
      icon: "/images/Grid/cert-ico.svg",
      title: gridItems[3].title,
      description: gridItems[3].description,
    },
    {
      icon: "/images/Grid/garant-ico.svg",
      title: gridItems[4].title,
      description: gridItems[4].description,
    },
    {
      icon: "/images/Grid/target-ico.svg",
      title: gridItems[5].title,
      description: gridItems[5].description,
    },
  ];

  const servicesData = t("serviceEU.services", {
    returnObjects: true,
  }) as Array<{
    title: string;
    description: string;
    list: string[];
  }>;

  const services = servicesData.map((service, index) => ({
    id: `0${index + 1}`,
    title: service.title,
    description: service.description,
    list: service.list,
  }));

  if (!faqData) {
    return <div>Loading...</div>; // Показуємо завантаження, поки дані не завантажені
  }

  return (
    <div>
      <Helmet>
        <title>{t("serviceEU.meta.title")}</title>
        <link rel="icon" href="/images/favicon.ico" type="image/x-icon" />
      </Helmet>
      <Nav />
      <Header images={headerSlider} />
      <ScrollingText />
      <GridComponent title={t("serviceEU.grid.title")} items={gridData} />
      <ServiceBlockBerlin services={services} />
      <RepairServiceBig />
      <OpenMenuBlock />
      <FaqBlock faqData={faqData} showAllButton={true} variant="mini" />
      <CookiePopupButton />
      <Footer />
    </div>
  );
};

export default ServiceEU;
